// src/services/api.js
// Camada de serviço — toda comunicação com o backend Spring Boot fica aqui.
//
// ┌─────────────────────────────────────────────────────────────────────────┐
// │  Em desenvolvimento o React roda na porta 3000 e o Spring Boot na 8080. │
// │  O "proxy" no package.json redireciona /api/* → localhost:8080,         │
// │  evitando erros de CORS sem precisar configurar nada no backend.        │
// │                                                                          │
// │  Em produção (npm run build) basta servir o build/ na mesma origem      │
// │  do Spring Boot (ex: pasta static/) e o proxy não é mais necessário.   │
// └─────────────────────────────────────────────────────────────────────────┘

// Caminho base da API — usa caminho relativo para funcionar com o proxy
const API_URL = "/api/produtos2";

// ─── Utilitário interno ──────────────────────────────────────────────────
// Extrai a mensagem de erro de uma resposta HTTP mal-sucedida.
// O Spring Boot geralmente devolve JSON com campo "message" ou "error".
async function extrairErro(response) {
  try {
    const body = await response.json();
    return body.message || body.error || `Erro HTTP ${response.status}`;
  } catch {
    return `Erro HTTP ${response.status}`;
  }
}

// ─── CONSULTAR TODOS (GET /api/produtos2) ────────────────────────────────
// Retorna: Produto[]
export async function getProdutos() {
  const response = await fetch(API_URL);
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── CONSULTAR POR ID (GET /api/produtos2/{id}) ──────────────────────────
// Retorna: Produto | lança erro 404 se não encontrado
export async function getProdutoById(id) {
  const response = await fetch(`${API_URL}/${id}`);
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── INSERIR (POST /api/produtos) ───────────────────────────────────────
// Body: { nome: String, preco: Double, estoque: Integer }
// Retorna: Produto criado (com id gerado pelo banco)
export async function createProduto(produto) {
  const response = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(produto),
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── ALTERAR (PUT /api/produtos/{id}) ───────────────────────────────────
// Body: { nome: String, preco: Double, estoque: Integer }
// Retorna: Produto atualizado
export async function updateProduto(id, produto) {
  const response = await fetch(`${API_URL}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(produto),
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── APAGAR (DELETE /api/produtos/{id}) ─────────────────────────────────
// Retorna: true em caso de sucesso
// Aceita resposta 200 com corpo OU 204 sem corpo (ambos comuns no Spring Boot)
export async function deleteProduto(id) {
  const response = await fetch(`${API_URL}/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return true;
}
